import * as React from 'react';
import cn from 'clsx';
import styles from '@sicredi/styles/_layout.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const Wrapper: React.FC<Props> = ({
  children,
  className,
  ...props
}) => (
  <div className={cn(styles['sicredi-layout-wrapper'], className)} {...props}>
    {children}
  </div>
);

export default Wrapper;
